import { appLifecycleListeners } from "./ps4AppLifecycleListeners";
import { webmafAction, wefmafActionResponseStates } from "../webmafActions";
import isBrowser from "../../../utils/isBrowser";

let deepLinkData;

function isApplicationEventSupported(event) {
  if (!appLifecycleListeners[event]) {
    throw new Error(
      // TODO consider moving this string to the errors file
      `The application doesn't support ${event} lifecycle event.`
    );
  }
  return true;
}

function getDeepLinkingData(value) {
  const deepLinkValue = isBrowser && window.atob && JSON.parse(window.atob(value));
  appLifecycleListeners.deepLink.forEach(listener => listener(deepLinkValue));
  return deepLinkValue;
}

function setDeepLinkData(data) {
  deepLinkData = data;
}

function initDeepLinking() {
  webmafAction("externalParameter", {}, ({ status, value }) => {
    status === wefmafActionResponseStates.ok && setDeepLinkData(getDeepLinkingData(value));
  });
  webmafAction("getExternalParameter", {}, ({ status, value }) => {
    status === wefmafActionResponseStates.ok && setDeepLinkData(getDeepLinkingData(value));
  });
}

initDeepLinking();

export const application = {
  async exit() {},
  // FIXME the on and off methods are repeated in the network and player (ps4). Given tha the logic is the same, we should create a common utility module.
  on(event, listener) {
    if (
      isApplicationEventSupported(event) &&
      !appLifecycleListeners[event].some(existingListener => listener === existingListener)
    ) {
      appLifecycleListeners[event].push(listener);
    }
  },
  off(event, listener) {
    if (isApplicationEventSupported(event)) {
      const listenerIndex = appLifecycleListeners[event].findIndex(existingListener => existingListener === listener);
      appLifecycleListeners[event].splice(listenerIndex, 1);
    }
  },
  /**
   * Returns the deeplinking data selected one to the client app
   *
   * @returns {Object} The selected title from the deeplinking list
   */
  getDeepLinkTitle() {
    return deepLinkData;
  },
  checkMagicRemote() {
    return false;
  }
};
